<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showAddOrUpdateDisciplinarySideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'420px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div class="sidebar-header-title">Add New Case</div>
            <div class="sidebar-header-sub-title"></div>
        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading" style="margin: 0 -14px;">

        <div class="bx-pager bx-default-pager">
            <div class="bx-pager-item" [class]="'active'" style="flex: 0 100% !important; text-align: left !important;">
                <a class="bx-pager-link" data-slide-index="0">Details</a>
            </div>
        </div>

        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 244px)'}"
                       [styleClass]="'app-scrollpanel'">

            <div class="flex flex-row">
                <div class="col-6 p-2">
                    <div class="new-diciplinary-label">Driver ID</div>
                    <p-autoComplete [(ngModel)]="selectComplaintUser"
                                    [suggestions]="users"
                                    (completeMethod)="searchUsers($event)"
                                    placeholder="Type Driver ID"
                                    field="UserName"
                                    [style]="{'width': '100%'}">
                    </p-autoComplete>
                </div>
                <div class="col-6 p-2">
                    <div class="new-diciplinary-label">Date and Time</div>
                    <p-calendar [(ngModel)]="disciplinary.OffenseDateTime" [showTime]="true" [showSeconds]="true"
                                [showIcon]="false" placeholder="Select date and time"
                                [style]="{'width': '100%'}"></p-calendar>
                </div>
            </div>

            <div class="flex flex-row">
                <div class="col-6 p-2">
                    <div class="new-diciplinary-label">Priority Level</div>
                    <p-dropdown placeholder="Select Priority" [(ngModel)]="disciplinary.PriorityTypeId" [options]="priorityTypes"
                                optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                </div>
                <div class="col-6 p-2">
                    <div class="new-diciplinary-label">Channel</div>
                    <p-dropdown placeholder="Select Channel" [(ngModel)]="disciplinary.Channel" [options]="disciplinaryChannelList"
                                optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                </div>
            </div>

            <div class="flex flex-row">
                <div class="col-6 p-2">
                    <div class="new-diciplinary-label">Prohibited Acts</div>
                    <p-dropdown placeholder="Please Select" [(ngModel)]="disciplinary.OffenseTypeId" [options]="offenseTypes"
                                optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                </div>
                <div class="col-6 p-2">
                    <div class="new-diciplinary-label">Offense Code</div>
                    <p-dropdown placeholder="Please Select" [(ngModel)]="disciplinary.CodeConductId" (onChange)="onCodeConductChange($event)" [options]="codeConducts"
                                optionLabel="Code" optionValue="Id" [showClear]="true" [editable]="true">   
                    </p-dropdown>
                </div>
            </div>

            <div class="flex flex-row">
                <div class="col-12 p-2">
                    <div class="new-diciplinary-label">Customer Affected?</div>
                    <div class="flex flex-wrap gap-3">
                        <div class="flex">
                            <p-radioButton value="true" [(ngModel)]="isCustomerAffected" inputId="affected1"></p-radioButton>
                            <label for="affected1" class="ml-2">Yes</label>
                        </div>

                        <div class="flex">
                            <p-radioButton value="false" [(ngModel)]="isCustomerAffected" inputId="affected2"></p-radioButton>
                            <label for="affected2" class="ml-2">No</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="disciplinary-hr"></div>

            <div class="flex flex-row">
                <div class="col-6 p-2">
                    <div class="new-diciplinary-label">Customer Name</div>
                    <input type="text" [(ngModel)]="disciplinary.CustomerName" placeholder="Enter Name" pInputText />
                </div>
                <div class="col-6 p-2">
                </div>
            </div>

            <div class="flex flex-row">
                <div class="col-6 p-2">
                    <div class="new-diciplinary-label">Customer Email</div>
                    <input type="text" [(ngModel)]="disciplinary.CustomerEmail" placeholder="Enter email address" pInputText />
                </div>
                <div class="col-6 p-2">
                    <div class="new-diciplinary-label">Customer Phone Number</div>
                    <input type="text" [(ngModel)]="disciplinary.CustomerPhone" placeholder="Enter phone number" pInputText />
                </div>
            </div>

            <div class="flex flex-row">
                <div class="col-12 p-2">
                    <div class="new-diciplinary-label">Notes</div>
                    <textarea rows="5" cols="30" [(ngModel)]="disciplinary.Note" placeholder="Please enter your notes here…" pInputTextarea [autoResize]="true"></textarea>
                </div>
            </div>

            <div class="flex flex-row">
                <div class="col-12 p-2">
                    <span class="disciplinary-representative-fullname-label">Xpress Representative:</span>
                    <span class="disciplinary-representative-fullname">{{representativeFullName}}</span>
                </div>
            </div>

        </p-scrollPanel>
    </div>

    <div class="flex justify-content-end mrg-10-0px p-4" *ngIf="!loading">
        <button class="bluedark-btn" pButton label="Submit" (click)="addOrUpdateDisciplinary()"></button>
    </div>

</p-sidebar>